import React from "react";

import "./wearables-v2.css";

type Props = {
  statusLabel: string;
  label: string;
  track: string;
  body: string;
  overlayOpen: boolean;
  onToggleDetails: () => void;
};

export default function WearablesContinuityCapsule({
  statusLabel,
  label,
  track,
  body,
  overlayOpen,
  onToggleDetails,
}: Props): JSX.Element {
  return (
    <>
      <div className="st-wearables-v2__topline">
        <span className="st-wearables-v2__status-badge">{statusLabel}</span>
        <button
          type="button"
          className="st-wearables-v2__button st-wearables-v2__button--ghost st-wearables-v2__button--compact"
          onClick={onToggleDetails}
        >
          Readiness Compass
        </button>
      </div>

      <div>
        <p className="st-wearables-v2__eyebrow">Wearables Continuity</p>
        <h2 className="st-wearables-v2__title">
          {label} · {track === "xr" ? "XR" : track}
        </h2>
        <p className="st-wearables-v2__body">{body}</p>
      </div>
    </>
  );
}